import { StorageObjectVersion } from "../../../../services/api/instances/storageApi/types/object_types";
import type { StorageObjectValue } from "../../../../services/api/instances/storageApi/types/service_types";

export const getLatestDateVersionValue = (
  versions: StorageObjectVersion<StorageObjectValue>[],
) =>
  versions?.reduce((latest, current) =>
    new Date(current.version_date as string) >
    new Date(latest.version_date as string)
      ? current
      : latest,
  );
